module.exports = __webpack_public_path__ + "static/media/home-vector.c546ddd9.svg";